var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chartdiv",staticClass:"AMCharts",class:("AMCharts--" + _vm.graph)})}
var staticRenderFns = []

export { render, staticRenderFns }